import React from 'react';
import styled from 'styled-components';

const FounderSectionContainer = styled.section`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 80px 0;
`;

const FounderContainer = styled.div`
  display: flex;
  gap: 50px;
  align-items: center;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const FounderImageContainer = styled.div`
  flex: 1;
  text-align: center;
  
  img {
    max-width: 100%;
    height: auto;
    border-radius: ${props => props.theme.borders.radius.regular};
    box-shadow: ${props => props.theme.shadows.regular};
  }
`;

const FounderDetailsContainer = styled.div`
  flex: 1;
`;

const FounderTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  margin-bottom: 10px;
  color: ${props => props.theme.colors.secondaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const FounderName = styled.h3`
  font-size: ${props => props.theme.fontSizes.xlarge};
  color: ${props => props.theme.colors.primaryColor};
  margin-bottom: 5px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.large};
  }
`;

const Credentials = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  margin-bottom: 5px;
  font-weight: ${props => props.theme.fontWeights.medium};
`;

const Position = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  margin-bottom: 20px;
  font-weight: ${props => props.theme.fontWeights.medium};
`;

const FounderBio = styled.div`
  p {
    margin-bottom: 20px;
    color: ${props => props.theme.colors.grey[600]};
    line-height: 1.8;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const FounderSection = () => {
  return (
    <FounderSectionContainer>
      <div className="container">
        <FounderContainer>
          <FounderImageContainer>
            <img src="/placeholder/400/500" alt="C. Kalyanasundaram" />
          </FounderImageContainer>
          
          <FounderDetailsContainer>
            <FounderTitle>Our Founder</FounderTitle>
            <FounderName>C. Kalyanasundaram</FounderName>
            <Credentials>M.E. (Structural), M.I.E., C.Eng.</Credentials>
            <Position>Former Superintending Engineer - PWD</Position>
            
            <FounderBio>
              <p>
                C. Kalyanasundaram brings decades of experience in structural engineering and design to KALS Academy. 
                After a distinguished career in the Public Works Department, where he served as a Superintending Engineer, 
                he established KALS Academy to share his knowledge and expertise with the next generation of engineers.
              </p>
              <p>
                His practical experience in managing and executing large-scale infrastructure projects, combined with his 
                academic background, has been instrumental in developing a curriculum that emphasizes both theoretical 
                understanding and practical application.
              </p>
              <p>
                Under his leadership, KALS Academy has become known for its rigorous training programs that prepare 
                students for the challenges of real-world engineering projects and competitive examinations.
              </p>
            </FounderBio>
          </FounderDetailsContainer>
        </FounderContainer>
      </div>
    </FounderSectionContainer>
  );
};

export default FounderSection;
